import { ButtonIcon, Tabs } from '@statsbomb/kitbag-components';
import { useAtomValue, useSetAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { selectedMetricsAtom } from '@/atoms/dataLocker/metrics';
import { clearFiltersAtom } from '@/atoms/filters/resetFilters';
import { numGeneralFiltersActiveAtom, numPlayerFiltersActiveAtom } from '@/atoms/queries/player/playerAggData';
import { playerDataLockerTabFiltersToClear } from '@/consts/filters/playerDataLocker';
import { FILTERS_TAB } from '@/consts/searchKeys';
import { PlayerDataLockerTabValue, Tab } from '@/types/tabs';
import { PlayerDataLockerGeneralFilters } from '../filters/PlayerDataLockerGeneralFilters';
import { PlayerDataLockerMetricFilters } from '../filters/PlayerDataLockerMetricFilters';
import { PlayerDataLockerPlayerFilters } from '../filters/PlayerDataLockerPlayerFilters';
import { PlayerAggsApplyFiltersButton } from './PlayerAggsApplyFiltersButton';

const tabComponents: Record<PlayerDataLockerTabValue, () => JSX.Element> = {
  general: PlayerDataLockerGeneralFilters,
  player: PlayerDataLockerPlayerFilters,
  metrics: PlayerDataLockerMetricFilters,
};

export const PlayerAggsFilters = () => {
  const { t } = useTranslation('filters');
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = (searchParams.get(FILTERS_TAB) || PlayerDataLockerTabValue.GENERAL) as PlayerDataLockerTabValue;
  const SelectedTabFilters = tabComponents[activeTab];

  const clearFilters = useSetAtom(clearFiltersAtom);
  const numGeneralFiltersActive = useAtomValue(numGeneralFiltersActiveAtom);
  const numPlayerFiltersActive = useAtomValue(numPlayerFiltersActiveAtom);
  const numMetricFiltersActive = useAtomValue(selectedMetricsAtom).length;

  return (
    <div className="h-full flex flex-col">
      <Tabs
        activeTab={activeTab}
        onTabChange={(_: MouseEvent, { value }: Tab<PlayerDataLockerTabValue>) => {
          const newSearch = new URLSearchParams(searchParams);
          newSearch.set(FILTERS_TAB, value);
          setSearchParams(newSearch);
        }}
        tabs={[
          {
            label: t('tab.general', { count: numGeneralFiltersActive }),
            value: 'general',
          },
          {
            label: t('tab.player', { count: numPlayerFiltersActive }),
            value: 'player',
          },
          {
            label: t('tab.metric', { count: numMetricFiltersActive }),
            value: 'metrics',
          },
        ]}
      />
      <div className="flex flex-col gap-4 p-4 h-full">
        {activeTab !== 'metrics' && (
          <div>
            <ButtonIcon
              displayText="right"
              variant="secondary"
              size="small"
              icon="Erase"
              onClick={() => clearFilters(playerDataLockerTabFiltersToClear[activeTab])}
            >
              {t('clear', { ns: 'general' })}
            </ButtonIcon>
          </div>
        )}
        <SelectedTabFilters />
      </div>
      <PlayerAggsApplyFiltersButton />
    </div>
  );
};
